import React, { useEffect, useRef, useState } from "react";
import "./EpisodeTag.css";
import { PopOverMenu } from "../PopOverMenu/PopOverMenu.js";

export const EpisodeTag = (props) => {
  let episodeId,
    episodeData,
    focusItem,
    setFocusItem,
    handleMouseEnter,
    handleMouseLeave;
  let menuRef = useRef(null);

  let [selectedItem, setSelectedItem] = useState(null);

  if (props.listControl) {
    let listControl = props.listControl;

    episodeId = listControl.episodeId;
    episodeData = listControl.episodeData;
    focusItem = listControl.focusItem;
    setFocusItem = listControl.setFocusItem;
    handleMouseEnter = listControl.handleMouseEnter;
    handleMouseLeave = listControl.handleMouseLeave;
  }

  let [flipTag, setFlipTag] = useState(false);

  let menuItems = [
    {
      id: flipTag ? "close_overview" : "open_overview",
      nav: { hasNav: false },
      name: flipTag ? "Close Overview" : "View Overview",
    },
    {
      id: "episode_link",
      nav: {
        hasNav: true,
        address: `/details/tv/${episodeData.show_id}/${episodeData.season_number}/${episodeData.episode_number}`,
      },
      name: "Go to Episode",
    },
  ];

  let episodeNumber = episodeData.episode_number;
  let title = episodeData.title;
  let overview = episodeData.overview;
  let runtime = episodeData.runtime;
  let posterPath = episodeData.poster_path;
  let releaseDate = episodeData.release_date;

  function handleFocus() {
    if (!focusItem) {
      setFocusItem(episodeId);
    } else {
      setFocusItem("");
    }
  }

  function handleFlip() {
    if (focusItem == episodeId) {
      setFlipTag(!flipTag);
    }
  }

  useEffect(() => {
    if (focusItem !== episodeId) {
      setFlipTag(false);
      setSelectedItem(false);
    }
  }, [focusItem]);

  useEffect(() => {
    if (selectedItem && selectedItem.includes("overview")) {
      handleFlip();
    }
  }, [selectedItem]);

  return (
    <div
      className="episode_tag_wrapper"
      onMouseEnter={() => handleMouseEnter(episodeId)}
      onMouseLeave={handleMouseLeave}
    >
      <div className="episode_tag_container">
        <div
          className={`episode_tag_poster_wrapper ${
            !flipTag ? "" : "ep_hidden"
          }`}
        >
          <img className="episode_tag_poster" src={posterPath} />
        </div>
        <div
          className={`episode_tag_content_wrapper ${
            !flipTag ? "" : "ep_hidden"
          }`}
        >
          <div className="episode_tag_name">
            Ep{episodeNumber}: {title}
          </div>
          <div className="episode_tag_info">
            <div className="episode_runtime">{runtime}</div>
            <div className="episode_date">{releaseDate}</div>
          </div>
        </div>
        <div
          className={`episode_tag_overview ${
            flipTag ? "" : "ep_hidden"
          } custom_scrollbar`}
        >
          {overview}
        </div>
      </div>
      <div className="episode_tag_control">
        <PopOverMenu
          menuItems={menuItems}
          menuRef={menuRef}
          focusItem={focusItem}
          id={episodeId}
          setSelectedItem={setSelectedItem}
        />
      </div>
    </div>
  );
};
